// extracted by mini-css-extract-plugin
export default {"margLower":"AdminRetiro_margLower__1EcIC","topRow":"AdminRetiro_topRow__eEMmn","cartaArea":"AdminRetiro_cartaArea__SaBgW","confi":"AdminRetiro_confi__S0DcH"};